import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import './index.css';
import * as serviceWorker from './serviceWorker';
import {oidcConfig} from "./auth";
import {AuthProvider} from "react-oidc-context";


ReactDOM.render(
  <React.StrictMode>
    <React.Suspense fallback="...loading languages">
        <AuthProvider {...oidcConfig}>
            <App />
        </AuthProvider>
    </React.Suspense>
  </React.StrictMode>,
  document.getElementById('root'),
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
